import * as React from 'react';

export interface IPublicTransportEventsBoxProp {
    events: PublicTransportTypesWrapper[];
    collapsible?: boolean;
    idPrefix?: string;
}

export class PublicTransportEvent {
    public trafficTypeId: number;
    public eventId: string;
    public message: string;
    public expanded?: boolean;
    public planned?: boolean;
    public sortIndex?: number;
    public trafficLine: string;
    public eventInfoUrl: string;
    public trafficStatus: string;
    public trafficStatusIconId?: number;
    public reportAt: Date;
}

export class PublicTransportStatus {
    public trafficTypeId: number;
    public trafficType: string;
    public expanded?: boolean;
    public hasPlannedEvent?: boolean;
    public trafficStatus: string;
    public provider: string;
    public trafficTypeIconId?: number;
    public trafficStatusIconId?: number;
    public reportAt?: Date;
}

export class PublicTransportTypesWrapper {
    public extraIcon: string;
    public status: PublicTransportStatus;
    public events: PublicTransportEvent[];
}

export class PublicTransportEventsBox extends React.Component<IPublicTransportEventsBoxProp> {
    public render(): JSX.Element {
        if (this.props.events === undefined || this.props.events === null || this.props.events.length === 0) {
            return null;
        }

        const events = this.props.events ?? [];
        const statuses = <ul className="sl-event-box__statuses mb-0">{events.map(this.renderStatus.bind(this))}</ul>;

        if (!this.props.collapsible) {
            return <div className="block__content sl-event-box">{statuses}</div>;
        }

        const boxCollapseId = `${this.getIdPrefix()}-box`;
        const hasError = events.some(
            (x) => x.status.trafficStatusIconId !== null && x.status.trafficStatusIconId !== undefined && x.status.trafficStatusIconId !== 910,
        );
        const statusLabel = hasError ? 'Pågående störningar finns' : 'Inga större störningar';

        return (
            <div className="block__content sl-event-box">
                <h2 className="h5 mb-0 yellow-border-bottom">
                    <button
                        className="sl-event-box__toggle-button btn btn-link collapsed text-decoration-none d-flex align-items-center justify-content-between"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={'#' + boxCollapseId}
                        aria-expanded="false"
                        aria-controls={boxCollapseId}
                    >
                        <span className="h5 mb-0">Kollektivtrafik</span>
                        <span className="sl-event-box__status-icons d-flex align-items-center">
                            <span
                                role="img"
                                aria-label={statusLabel}
                                title={statusLabel}
                                className={'SLicon ' + (hasError ? 'sprite-912' : 'sprite-910')}
                            />
                            <i className="icon-animated icon-up-open" aria-hidden="true" />
                        </span>
                    </button>
                </h2>
                <div className="collapse pt-3" id={boxCollapseId}>
                    {statuses}
                </div>
            </div>
        );
    }

    private getIdPrefix(): string {
        return this.props.idPrefix || 'sl-event-box';
    }

    private renderStatus(item: PublicTransportTypesWrapper, index: number): JSX.Element {
        const events = item.events.sort((x, y) => x.sortIndex - y.sortIndex);
        const extraIcon = item.extraIcon !== '' ? <span title="Statusikon" className={'SLicon ' + item.extraIcon} /> : null;
        const icon =
            item.status.trafficStatusIconId !== null && item.status.trafficStatusIconId !== undefined ? (
                <span title="Statusikon" className={'SLicon sprite-' + item.status.trafficStatusIconId} />
            ) : (
                <span title="Statusikon" className={'SLicon sprite-910'} />
            );

        const collapseId = `${this.getIdPrefix()}-${index}`;

        return (
            <li key={index} className="sl-event-box__status">
                <button
                    className="sl-event-box__toggle-button btn btn-link collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={'#' + collapseId}
                    aria-expanded="false"
                    aria-controls={collapseId}
                >
                    <span className="h6">{item.status.trafficType}</span>
                    <span className="sl-event-box__status-icons d-flex align-items-center">
                        {extraIcon}
                        {icon}
                        <i className="icon-animated icon-up-open" aria-hidden="true" />
                    </span>
                </button>
                <ul className="sl-event-box__events mb-0 collapse" id={collapseId}>
                    {events.length > 0 ? (
                        events.map(this.renderEvent.bind(this))
                    ) : (
                        <li className="sl-event-box__event">
                            <span className="SLicon sprite-910" title="Statusikon" /> Inga större störningar
                        </li>
                    )}
                </ul>
            </li>
        );
    }

    private renderEvent(item: PublicTransportEvent, index: number): JSX.Element {
        const statusId = item.trafficStatusIconId !== null ? item.trafficStatusIconId : 910;

        let content = (
            <span>
                <span className="fw-bold">
                    <span className={'SLicon sprite-' + statusId} />
                    {item.trafficLine}:
                </span>
                <br />
                <span>{item.message}</span>
            </span>
        );

        if (item.eventInfoUrl !== '') {
            content = (
                <div>
                    <a href={item.eventInfoUrl}>
                        <span className="fw-bold">
                            <span className={'SLicon sprite-' + statusId} />
                            {item.trafficLine}:
                        </span>
                    </a>
                    <br />
                    <span>{item.message}</span>
                </div>
            );
        }

        return (
            <li key={index} className="sl-event-box__event">
                {content}
            </li>
        );
    }
}
